<label>
  <div class="mat-raised-button upload-button" [attr.disabled]="disabled ? '' : null">
    <ng-content></ng-content>
  </div>
  <input type="file" #fileInput [accept]="accept" class="cdk-visually-hidden" [disabled]="disabled"
    (change)="onSelect($event)">
</label>
